let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7kt5I"), load("bI3DO"), load("luyQ6"), load("32ARE"), load("c0lrw")]).then(() => parcelRequire('7QGXJ'));